var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container pt-4"},[_c('h1',{staticClass:"text-center mb-4"},[_vm._v("Settings")]),_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{staticClass:"text-center py-3",attrs:{"md":"8"}},[_c('dashboard-tiles',{attrs:{"items":_vm.settingsNavItems}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }